import React from 'react';
import './InteriorDesign.css'; // Using the same CSS file
import useScrollToTop from '../components/useScrollToTop';
import ReusableLanding from '../components/ReusableLanding';
import image2 from '../img/exterior.webp';
import kitchenimg from '../img/kitchen_img_1.avif';
import kitchenimg2 from '../img/kitchen_img_2.avif';
import kitchenimg3 from '../img/kitchen_img_3.avif';
import kitchenimg4 from '../img/kitchen_img_4.avif';
import kitchenimg5 from '../img/kitchen_img_5.avif';
import designimg from '../img/ideas_img_1.avif';


const DesignIdeas = () => {
  useScrollToTop();
  return (
    <>
      <ReusableLanding
        imageUrl={image2}
        title="Design Ideas"
        description="Looking for inspiration for your next interior design project? At Housekaar, we curate a collection of design ideas that showcase the latest trends and styles in home and office interiors."
      />
      <div className="interior-design-page">

        <section>
          <h2>Modern Minimalist Design</h2>
          <p>
            Modern minimalist design focuses on simplicity, clean lines, and functionality. We use neutral color palettes, natural materials, and minimal decor to create a serene and uncluttered space.
          </p>
          <div className="room-grid"> {/* Using the room-grid class for image layout */}
            <img src={designimg} alt="Minimalist Idea 1" loading="lazy"/> {/* More descriptive alt text */}
            <img src={kitchenimg2} alt="Minimalist Idea 2" loading="lazy"/> {/* More descriptive alt text */}
            <img src={kitchenimg3} alt="Minimalist Idea 3" loading="lazy"/> {/* More descriptive alt text */}
          </div>
          <ul>
            <li>Open-plan layouts</li>
            <li>Neutral color palettes</li>
            <li>Minimalist furniture and decor</li>
            <li>Natural materials and finishes</li>
          </ul>
        </section>
{/*
        <div>
          <h1>360 Immersive Interiors</h1>
          <SimplePanoramaWithZoom imageUrl={myPanorama}
            sphereWidthSegments={60}
            sphereHeightSegments={30}
            dragSensitivity={0.06}
            usePixelRatio={true}   />
        </div>*/}

        <section>
          <h2>Industrial Chic Design</h2>
          <p>
            Industrial chic design combines raw and unfinished elements with modern and sophisticated touches. We use exposed brick, metal accents, and vintage furniture to create a unique and edgy look.
          </p>
          <div className="room-grid"> {/* Using the room-grid class for image layout */}
            <img src={kitchenimg3} alt="Industrial Idea 1" loading="lazy"/> {/* More descriptive alt text */}
            <img src={kitchenimg4} alt="Industrial Idea 2" loading="lazy"/> {/* More descriptive alt text */}
            <img src={kitchenimg5} alt="Industrial Idea 3" loading="lazy"/> {/* More descriptive alt text */}
          </div>
          <ul>
            <li>Exposed brick and concrete walls</li>
            <li>Metal accents and lighting fixtures</li>
            <li>Vintage and reclaimed furniture</li>
            <li>Raw and unfinished materials</li>
          </ul>
        </section>

        <section>
          <h2>Bohemian Eclectic Design</h2>
          <p>
            Bohemian eclectic design is all about mixing and matching patterns, colors, and textures to create a vibrant and eclectic space. We use a variety of textiles, plants, and travel-inspired decor to create a warm and inviting atmosphere.
          </p>
          <div className="room-grid"> {/* Using the room-grid class for image layout */}
            <img src={kitchenimg} alt="Bohemian Idea 1" loading="lazy"/> {/* More descriptive alt text */}
            <img src={kitchenimg2} alt="Bohemian Idea 2" loading="lazy"/> {/* More descriptive alt text */}
            <img src={kitchenimg5} alt="Bohemian Idea 3" loading="lazy"/> {/* More descriptive alt text */}
          </div>
          <ul>
            <li>Mix and match patterns and colors</li>
            <li>Textiles and rugs</li>
            <li>Plants and greenery</li>
            <li>Travel-inspired decor</li>
          </ul>
        </section>

        <section>
          <h2>Sustainable and Eco-Friendly Design</h2>
          <p>
            Sustainable and eco-friendly design focuses on using natural materials, energy-efficient appliances, and eco-friendly practices to create a healthy and environmentally responsible space.
          </p>
          <div className="room-grid"> {/* Using the room-grid class for image layout */}
            <img src={kitchenimg} alt="Sustainable Idea 1" loading="lazy"/> {/* More descriptive alt text */}
            <img src={kitchenimg5} alt="Sustainable Idea 2" loading="lazy"/> {/* More descriptive alt text */}
          </div>
          <ul>
            <li>Natural and reclaimed materials</li>
            <li>Energy-efficient appliances and lighting</li>
            <li>Indoor plants and air-purifying systems</li>
            <li>Sustainable furniture and decor</li>
          </ul>
        </section>

      </div>
    </>
  );
};

export default DesignIdeas;